import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllServiceJobStatusAutocomplete } from './useServiceJobStatusAutocomplete';

export const useCreateServiceJobStatusMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IServiceJobStatus) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			status,
			impersonationContext,
		}: {
			status: Api.IServiceJobStatus;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IServiceJobStatus>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'ServiceJob/status',
				}),
				'POST',
				status
			);
		},
		onError,
		onSuccess: data => {
			invalidateAllServiceJobStatusAutocomplete();
			onSuccess?.(data);
		},
	});
};
